import { Spinner } from "react-bootstrap";

export default function Loader() {
    return (
        <div style={{minHeight: "450px"}} className=" d-flex align-items-center justify-content-center">
            <Spinner animation="grow" role="status" size="lg" />
        </div>
    )
}